import moment from "moment-timezone";
moment.tz.setDefault("Asia/Kuwait");
export default moment;
